export default {
  GET_BANNER: "/SieuTriNhoHocDuong/GetBanner",
  GET_PRODUCT_LIST: "/SieuTriNhoHocDuong/ProductList",
  GET_PRODUCT_LIST_V2: "/SieuTriNhoHocDuong/ItemList",
}
